var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Dollar Sign",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 582",
    d: "M4.584 16.565a.849.849 0 0 1-.635-.257.861.861 0 0 1-.251-.624v-.867a6.321 6.321 0 0 1-1.513-.272 7.582 7.582 0 0 1-1.114-.445.919.919 0 0 1-.517-.58 1.092 1.092 0 0 1 .037-.72.907.907 0 0 1 .472-.5.9.9 0 0 1 .79.066 5.812 5.812 0 0 0 .989.389 5.25 5.25 0 0 0 1.55.2 2.46 2.46 0 0 0 1.447-.323.977.977 0 0 0 .428-.808.851.851 0 0 0-.3-.661 2.379 2.379 0 0 0-1.063-.426l-1.619-.357Q.6 9.793.6 7.53a2.855 2.855 0 0 1 .84-2.086A3.916 3.916 0 0 1 3.7 4.372v-.926a.861.861 0 0 1 .251-.624.849.849 0 0 1 .635-.257.832.832 0 0 1 .62.257.861.861 0 0 1 .251.624v.881a6.352 6.352 0 0 1 1.129.264 3.914 3.914 0 0 1 1.026.5.906.906 0 0 1 .435.566.962.962 0 0 1-.066.654.836.836 0 0 1-.48.433 1.007 1.007 0 0 1-.8-.11 5.348 5.348 0 0 0-.871-.323 4.392 4.392 0 0 0-1.166-.132 2.253 2.253 0 0 0-1.343.353 1.078 1.078 0 0 0-.487.911.838.838 0 0 0 .288.654 2.318 2.318 0 0 0 1.011.419l1.638.353a4.011 4.011 0 0 1 2.068 1.004 2.468 2.468 0 0 1 .672 1.785 2.716 2.716 0 0 1-.849 2.057 4.134 4.134 0 0 1-2.207 1.043v.925a.861.861 0 0 1-.251.624.832.832 0 0 1-.62.258z",
    transform: "translate(-.51 -2.565)",
    style: {
      fill: "#5c5c5c"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/Dollar Sign.d2418696.svg";
export { ForwardRef as ReactComponent };